/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React from 'react';

import { Checkbox, CheckboxProps } from '@mui/material';
import styled from 'styled-components';

const StyledCheckbox = styled(Checkbox)({})

const ArgosCheckbox = (props: CheckboxProps) => {
  return (
    <StyledCheckbox
      {...props}
    />
  )
}

export default ArgosCheckbox
